import { Account } from "types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all accounts
export const getAccounts = async (branch_id?: string | number) => {
  const url = branch_id
    ? `${ServiceEndpoints.ACCOUNTS}?branch_id=${branch_id}`
    : ServiceEndpoints.ACCOUNTS;

  return axios
    .get(url)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new accounts
export const createAccount = async (data: FormData) => {
  return axios
    .post(ServiceEndpoints.ACCOUNTS, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an account by ID
export const updateAccount = async (id: string, data: Account) => {
  const { ...accountData } = data;

  return axios
    .put(`${ServiceEndpoints.ACCOUNTS}/${id}`, accountData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get an account by its ID
export const getAccountById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.ACCOUNTS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete an account by ID
export const deleteAccount = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.ACCOUNTS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
